import type { Config } from '@/adapters/primitive/_contract/config';

const SHATTER_GOLDEN_ANGLE_RADIANS = 2.399963229728653;

/** Rings fly apart along a golden-angle spiral so no two shards overlap, growing outward by index. */
export function toShatterOffset(args: {
    memberIndex: number;
    scatter: number;
    spread: number;
}): [number, number, number] {
    if (args.scatter === 0) return [0, 0, 0];
    const angle = args.memberIndex * SHATTER_GOLDEN_ANGLE_RADIANS;
    const distance = args.scatter * args.spread * (args.memberIndex + 1);
    return [Math.cos(angle) * distance, Math.sin(angle) * distance, 0];
}

export function toShatterSpread(config: Config): number {
    return config.base.display.wheel.ringWidth + config.natural.display.wheel.ringGap;
}
